export default "__VITE_ASSET__dyHD4PWp__"